import { BaseModule } from '@mc/tangram-core'

export class LotteryList extends BaseModule {
  id = ''
  name = 'lottery_list'

  constructor(options) {
    super(options)
    let shouldBuildModule =
      options.data.lottery_list && options.data.lottery_list.length > 0
    if (options.data.dataType === 2) {
      this.name = 'coupon_lottery'
      shouldBuildModule =
        options.data.coupon_list && options.data.coupon_list.length > 0
    }
    if (shouldBuildModule) {
      this.id = options.id
      this.layoutType = options.layoutType
      this.backgroundImage = options.style.bgImg
      this.lotteryList = options.data.lottery_list || []
      this.couponList = options.data.coupon_list || []
    } else {
      return {}
    }
  }

  render() {
    const {
      id,
      pageId,
      name,
      containerStyle,
      backgroundImage,
      lotteryList,
      couponList
    } = this
    return {
      id,
      pageId,
      renderIdentifier: name,
      containerStyle,
      backgroundImage,
      lotteryList,
      couponList
    }
  }
}
